<template>
  <cc-container class="return-list">
    <cc-header-nav title="退货管理" url="/#/management">
      <cc-svg-icon @click="showDatePicker" size="20px" slot="right" icon-class="calendar"></cc-svg-icon>
    </cc-header-nav>
    <cc-fade>
      <div style="position:relative;">
        <cc-date-filter
          v-show="dateFilterVisible"
          @search="handleDateFilter"
          @cancel="emptyData"
          ref="dateFilter"
        ></cc-date-filter>
      </div>
    </cc-fade>
    <div class="search-box" style="border-bottom:5px solid #eeeeee;">
      <input
        v-model="return_number"
        class="input-search"
        type="text"
        placeholder="退货单搜索"
        @keyup.13="search()"
      />
      <cc-svg-icon
        size=".16rem"
        @click="return_number=''"
        class-name="search-icon"
        :icon-class="iconVisible?'cancel':'search'"
      ></cc-svg-icon>
    </div>
    <cc-main id="container">
      <van-tabs @click="handleTabClick" color="#1BB0D9" v-model="active" :line-height="1">
        <van-tab title="全部退单"></van-tab>
        <van-tab title="待审核"></van-tab>
        <van-tab title="待退货"></van-tab>
        <van-tab title="已完成"></van-tab>
        <van-tab title="已失效"></van-tab>
      </van-tabs>
      <van-list
        class="return-list"
        v-model="m_loading"
        :finished="m_finished"
        :finished-text="m_finishedText"
        @load="mHandlePullUpLoadMore"
        :immediate-check="m_immediateCheck"
      >
        <cc-not-order v-if="list.length === 0 && m_loading === false" tip="亲，暂无相关退货单哦"></cc-not-order>
        <cc-animation-list>
          <router-link
            :to="`/order/return/${item.id}`"
            tag="section"
            class="return-item"
            v-for="item in list"
            :key="item.id"
          >
            <div class="return-top">
              <p>退货单号：{{ item.return_number }}</p>
              <p style="color: #1BB0D9;">{{ item.state | getReturnState }}</p>
            </div>
            <div class="return-middle">
              <div class="return-img-list">
                <img
                  class="return-img"
                  v-for="good in item.goods.slice(0, 3)"
                  :key="good.id"
                  v-lazy="good.image"
                />
                <i class="return-tips">共{{ item.goods.length }}件</i>
              </div>
            </div>
            <div class="return-bottom">
              <!-- <p>来源单据：{{item.delivery_order_number}}</p> -->
              <p>退货类型：{{ item.price > 0 ? "退货退款" : "仅退货" }}</p>
              <p v-if="['0', '2'].includes(item.state)">
                <van-button
                  style="background: #1BB0D9;border-color: #1BB0D9;"
                  size="small"
                  type="primary"
                  @click.stop="cancel(item)"
                >取消退货申请</van-button>
              </p>
              <p>
                <cc-svg-icon
                  class="pr10"
                  icon-class="delete"
                  @click.stop="del(item)"
                  v-if="['1', '5', '6'].includes(item.state)"
                ></cc-svg-icon>
              </p>
            </div>
          </router-link>
        </cc-animation-list>
      </van-list>
    </cc-main>
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'
import { mapActions, mapGetters } from 'vuex'
import { Lazyload, List, Tab, Tabs, Dialog, Button } from 'vant'

import { types } from '../../../../store/modules/order'

import ListMixin from '@/mixins/list'
import { ResultCode } from '@/const/ResultCode'
Vue.use(Lazyload)
  .use(List)
  .use(Tab)
  .use(Tabs)
  .use(Dialog)
  .use(Button)
export default {
  name: 'return-list',
  mixins: [ListMixin],
  components: {},
  data () {
    return {
      // 搜索清除图标的显示隐藏
      iconVisible: false,
      start_time: null,
      list: [],
      // 搜索框
      return_number: '',
      // 默认选择第一个 Tab
      active: 0,
      // 状态
      state: -1,
      dateFilterVisible: false
    }
  },
  filters: {
    /**
     * @description 获取退货单状态
     */
    getReturnState (type) {
      var state = {
        0: '待审核',
        1: '已取消',
        2: '待退货',
        3: '待入库',
        4: '已完成',
        5: '已作废',
        6: '验收不通过'
      }
      return state[type] || `无当前状态${type}`
    }
  },
  computed: {
    ...mapGetters(['getReturnList', 'deleteReturn', 'offReturn'])
  },
  watch: {
    return_number () {
      this.return_number.length > 0
        ? (this.iconVisible = true)
        : (this.iconVisible = false)
    }
  },
  created () {
    this.m_page.limit = 5
    this.loadData()
  },
  activated () {
    if (this.$route.query.r && this.$route.query.r.toString() === '1') {
      this.search()
      location.hash = `#${this.$route.path}`
    }
  },
  methods: {
    ...mapActions([
      types.GET_RETURN_LIST,
      types.DELETE_RETURN,
      types.OFF_RETURN
    ]),
    handleDateFilter ({ startDate, endDate }) {
      this.start_time = startDate
      this.end_time = endDate
      this.search()
      this.dateFilterVisible = false
    },
    showDatePicker () {
      this.dateFilterVisible = ~this.dateFilterVisible
    },
    emptyData ({ startDate, endDate }) {
      this.$refs.dateFilter.startDate = ''
      this.$refs.dateFilter.endDate = ''
    },
    search () {
      this.mReset()
      const reset = true
      this.loadData(reset)
    },
    handleTabClick (index, title) {
      const stateMap = {
        全部退单: -1,
        待审核: 0,
        待退货: 2,
        已完成: 4,
        已失效: 5
      }
      this.state = stateMap[title]
      this.search()
    },
    /**
     * @description 删除退款记录
     */
    del (item) {
      Dialog.confirm({
        title: '提示',
        message: '你确定要删除退货记录吗？'
      })
        .then(async val => {
          await this.DELETE_RETURN({
            id: item.id
          })
          this.$tips(
            this.deleteReturn,
            {
              tip: true
            },
            () => {
              this.list = this.list.filter(l => l.id !== item.id)
              // this.list.splice(this.list.findIndex(i => i.id === item.id), 1)
            }
          )
        })
        // .catch(err => {
        .catch(() => {
        })
    },
    /**
     * @description 取消退货申请
     */
    cancel (item) {
      Dialog.confirm({
        title: '提示',
        message: '确认取消退货申请吗？'
      })
        .then(async success => {
          await this.OFF_RETURN({
            id: item.id
          })
          this.$tips(
            this.offReturn,
            {
              tip: true,
              duration: 1500
            },
            res => {
              item.state = '1'
            }
          )
        })
        .catch(calcel => {
        })
    },
    async loadData (reset) {
      if (reset) {
        this.list = []
      }
      this.mRequest()
      await this.GET_RETURN_LIST({
        page: this.m_page.curr,
        limit: this.m_page.limit,
        return_number: this.return_number,
        start_time: this.start_time,
        end_time: this.end_time,
        state: this.state
      })
      if (this.getReturnList.status === ResultCode.SUCCESS) {
        const data = this.getReturnList.data

        if (data.return_data.length === 0) {
          this.mEnd()
          if (this.list.length === 0) {
            this.m_finishedText = ''
            this.mEnd()
          }
        } else {
          this.list = [...this.list, ...data.return_data]
          if (data.return_data.length < 10) {
            this.m_finishedText = '已全部加载完成'
            this.mEnd()
          }
        }
        this.mSuccess()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~styles/index.scss";
.return-list {
  background: #fff;
  .search-box {
    height: 40px;
    position: relative;
    @include center(column);
    .input-search {
      height: 28px;
      width: 91%;
      border-radius: 2px;
      border: 1px solid $border-color-base;
      padding-left: 10px;
      font-size: 12px;
    }
    .search-icon {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto 0;
      right: 20px;
    }
  }
  .return {
    &-list {
      @include flex(column);
    }
    &-item {
      box-sizing: border-box;
      padding: 10px;
      border: 1px solid $border-color-base;
      border-left: 0;
      border-right: 0;
      box-shadow: $box-shadow-base;
      margin-bottom: 8px;
    }
    &-top {
      @include flex(row);
      padding-bottom: 12px;
      border-bottom: 1px solid $border-color-base;
      justify-content: space-between;
      font-size: 12px;
      color: $heading-color;
      font-weight: 700;
      .price {
        color: #eb1f1f;
        font-weight: 700;
      }
    }
    &-middle {
      padding: 15px 0;
      border-bottom: 1px solid $border-color-base;
      @include flex(row);
      align-items: center;
      .return-tips {
        width: 60px;
        height: 60px;
        background: #eeeeee;
        color: #777777;
        font-size: 12px;
        float: right;

        @include center(row);
      }
    }
    &-bottom {
      padding-top: 10px;
      font-size: 11px;

      @include flex(row);
      justify-content: space-between;
      align-items: center;
      > p:first-child {
        // width: 150px;
        flex: 1;
        box-sizing: border-box;
      }
      > p:nth-child(2) {
        // flex: 1;
        text-align: left;
      }
    }
    &-img {
      width: 60px;
      height: 60px;
      border: 1px solid $border-color-base;
      margin-right: 25px;
      &-list {
        width: 100%;
      }
    }
  }
}
</style>
<style lang="scss">
.van-tabs__line {
  bottom: 20px;
}
</style>
